import request from '@/utils/request'

// log error
export function queryLogError(data) {return request({url: 'sys/log_operate/list',method: 'post',data})}
export function queryLogErrorDetail(data) {return request({url: 'sys/log_operate/detail',method: 'post',data})}

// log login
export function queryLogLogin(data) {return request({url: 'sys/log_login/query',method: 'post',data})}

// log operate
export function queryLogOperate(data) {return request({url: 'sys/log_operate/list',method: 'post',data})}

// log data
export function queryLogUpdate(data) {return request({url: 'sys/log_update/query',method: 'post',data})}


export function querySysDictInfo(data) { return request({ url: '/sys/dict_info/query', method: 'post', data }) }
export function createSysDictInfo(data) { return request({ url: '/sys/dict_info/create', method: 'post', data }) }
export function updateSysDictInfo(data) { return request({ url: '/sys/dict_info/update', method: 'post', data }) }
export function deleteSysDictInfo(data) { return request({ url: '/sys/dict_info/delete', method: 'post', data }) }
export function detailSysDictInfo(data) { return request({ url: '/sys/dict_info/detail', method: 'post', data }) }
export function updatePoundStatus(data) { return request({ url: '/sys/dict_info/update_pound_status', method: 'post', data }) }


export function querySysParam(data) { return request({ url: '/sys/param/query', method: 'post', data }) }
export function createSysParam(data) { return request({ url: '/sys/param/create', method: 'post', data }) }
export function updateSysParam(data) { return request({ url: '/sys/param/update', method: 'post', data }) }
export function deleteSysParam(data) { return request({ url: '/sys/param/delete', method: 'post', data }) }
export function detailSysParam(data) { return request({ url: '/sys/param/detail', method: 'post', data }) }
export function updateStatusSysParam(data) { return request({ url: '/sys/param/update_status', method: 'post', data }) }

export function  querySysAppVersion(data) { return request({ url: '/sys/app_version/query', method: 'post', data }) }
export function createSysAppVersion(data) { return request({ url: '/sys/app_version/create', method: 'post', data }) }
export function updateSysAppVersion(data) { return request({ url: '/sys/app_version/update', method: 'post', data }) }
export function deleteSysAppVersion(data) { return request({ url: '/sys/app_version/delete', method: 'post', data }) }
export function detailSysAppVersion(data) { return request({ url: '/sys/app_version/detail', method: 'post', data }) }